module.exports = __webpack_public_path__ + "fonts/iconfont.dd7d9a58.ttf";